import Vue from 'vue'
import VueResource from 'vue-resource'
import { container } from '../services/container'
Vue.use(VueResource)

export class DeliveryApi {
	constructor () {
		this.url = process.env.VUE_APP_API_URL
	}
  
  getAccessToken() {
    return container.get('services.oauth').getToken()
  }

	updateDelivery (params) { 
		return Vue.http.put(this.url + '/ore/user/deliveries', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		} })
	}

	createDelivery (params) { 
		return Vue.http.post(this.url + '/ore/user/deliveries', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		} })
	}

	deleteDelivery (params) {
		return Vue.http.delete(this.url + '/ore/user/deliveries', { params, headers: {
    		Authorization: 'Bearer ' + this.getAccessToken()
   		} })
	}

	getDelivery (vars) { 
		var params = {} 
		if (vars && vars.params) params = vars.params
		return Vue.http.get(this.url + '/ore/user/deliveries', { params: params, headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		} }) 
	} 

	getTimeRanges (vars) {
		var params = {} 
		if (vars && vars.params) params = vars.params
		return Vue.http.get(this.url + '/ore/user/time-ranges', { params: params, headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		} })
	}

	createTimeRanges (params) {
		return Vue.http.post(this.url + '/ore/user/time-ranges', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		} })	
	}

	updateTimeRanges (params) {
		return Vue.http.put(this.url + '/ore/user/time-ranges', params, { headers: {
			Authorization: 'Bearer ' + this.getAccessToken()
		} })
	}

	deleteTimeRanges (params) {
		return Vue.http.delete(this.url + '/ore/user/time-ranges', { params, headers: {
    		Authorization: 'Bearer ' + this.getAccessToken()
   		} })
	}
}
